import { env } from '@/env'

export const API_BASE = env.VITE_API_URL ?? 'http://localhost:8000/api'

export type Language = {
  code: string;
  name: string;
  flag: string;
};

export const languages: Language[] = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
];
